import {
  DefaultToastOptions,
  ToastBar,
  Toaster,
} from 'react-hot-toast'

import CircleCheckFill from '@/components/icons/circle-check-fill.svg'
import CircleXFill from '@/components/icons/circle-x-fill.svg'

const toastOptions: DefaultToastOptions = {
  style: {
    borderRadius: '0.5rem',
    padding: '0.75rem 1.25rem 0.75rem 0.75rem',
    gap: '0.25rem',
    color: 'white',
  },
  error: {
    style: {
      background: 'var(--color-red-bg)',
    },
  },
  success: {
    style: {
      background: 'var(--color-green-bg)',
    },
  },
}

export default function ToastProvider() {
  return (
    <Toaster toastOptions={toastOptions}>
      {(toast) =>
        <ToastBar toast={toast}>
          {({ message }) => (
            <div className="grid grid-cols-[20px_1fr] gap-2">
              {toast.type === 'error' && <CircleXFill className="[&_path]:fill-white shrink fill-destructive size-5" />}
              {toast.type === 'success' && <CircleCheckFill className="[&_path]:fill-white shrink fill-success size-5" />}
              <div className="text-sm grow-0 *:m-0!">{message}</div>
            </div>
          )}
        </ToastBar>
      }
    </Toaster>
  )
}
